/*
 *
 * Auth reducer
 *
 */
import { produce } from 'immer';

import {
  ACCOUNT_INFO_PAGE_ADD_DOMAIN_SUCCESS,
  ACCOUNT_INFO_PAGE_REMOVE_DOMAIN_SUCCESS,
  EXTEND_TRIAL,
} from 'containers/MyAccountPage/pages/AccountInfoPage/constants';

import {
  UPGRADE_ACCOUNT_PAGE_ADD_DOMAIN_SUCCESS,
  UPGRADE_ACCOUNT_PAGE_REMOVE_DOMAIN_SUCCESS,
  UPGRADE_ACCOUNT_IN_PROGRESS,
  UPGRADE_ACCOUNT_RESET,
} from 'containers/BillingPage/pages/UpgradeAccountPage/constants';

export const initialState = {
  userData: null,
  token: localStorage.getItem('token') || null,
  errorMessage: null,
  loading: null,
};

const authReducer = (state = initialState, action) =>
  produce(state, (draft) => {
    switch (action.type) {
      case 'AUTH/LOGIN_SUCCESS':
        draft.token = action.payload;
        draft.loading = false;
        draft.errorMessage = null;
        break;
      case 'AUTH/LOGIN_ERROR':
        draft.errorMessage = action.payload;
        draft.loading = false;
        break;
      case 'AUTH/LOGIN':
        draft.errorMessage = null;
        draft.loading = true;
        break;
      case 'AUTH/LOGOUT':
        draft.userData = null;
        draft.token = null;
        draft.errorMessage = null;
        draft.loading = null;
        break;
      case 'AUTH/FETCH_USER_DATA_SUCCESS':
        draft.userData = action.payload;
        draft.errorMessage = null;
        break;
      case 'AUTH/FETCH_USER_DATA_ERROR':
        draft.errorMessage = action.payload;
        break;
      case 'AUTH/UPDATE_USER_DATA':
        draft.userData = { ...draft.userData, ...action.payload };
        draft.openModal = true;
        break;

      case ACCOUNT_INFO_PAGE_ADD_DOMAIN_SUCCESS:
        draft.userData.domains.push(action.payload);
        break;

      case ACCOUNT_INFO_PAGE_REMOVE_DOMAIN_SUCCESS:
        draft.userData.domains.splice(
          draft.userData.domains.indexOf(action.payload),
          1,
        );
        break;

      case UPGRADE_ACCOUNT_RESET:
        draft.userData.infoReset = !draft.userData.infoReset;
        break;

      case UPGRADE_ACCOUNT_PAGE_ADD_DOMAIN_SUCCESS:
        // draft.userData.domains.push(action.payload);
        // draft.userData.editDomainInProgess = true;
        break;

      case UPGRADE_ACCOUNT_PAGE_REMOVE_DOMAIN_SUCCESS:
        // draft.userData.domains.splice(
        //   draft.userData.domains.indexOf(action.payload),
        //   1,
        // );
        // draft.userData.editDomainInProgess = true;
        break;

      case UPGRADE_ACCOUNT_IN_PROGRESS:
        draft.userData.domains = action.payload;
        break;

      case EXTEND_TRIAL:
        draft.userData.paidUntil = action.payload;
        break;
      default:
        return state;
    }
  });

export default authReducer;
